import { render, staticRenderFns } from "./ViewOrderPublic.vue?vue&type=template&id=a9ac22b8"
import script from "./ViewOrderPublic.vue?vue&type=script&lang=js"
export * from "./ViewOrderPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports